export const AMT_SUBMIT_URL: string = 'https://www.mturk.com/mturk/externalSubmit';
export const AMT_SANDBOX_SUBMIT_URL: string = 'https://workersandbox.mturk.com/mturk/externalSubmit';